export default {
  dosomething(state) {
    state;
  }
};
